<div class="wrapper">
  <nav class="navbar-expand-lg navbar-dark bg-primary">
    <div class="container-fluid">
      <a class="navbar-brand">
        <img ngSrc="./assets/header_logo.svg" width="130" height="50" alt="Logo" class="logo"/>
      </a>
      <button
        class="navbar-toggler me-2"
        type="button"
        (click)="isNavBarCollapsed.set(!isNavBarCollapsed())"
        [attr.aria-expanded]="!isNavBarCollapsed"
        >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div [ngbCollapse]="isNavBarCollapsed()" class="collapse navbar-collapse">
        <ul class="navbar-nav" ngbNav [activeId]="$activeRoute | async">
          @for (link of links; track link.title) {
            @if (canActivate(link.canActivate) && (link.requireLogin ? this.userService.isAuthenticated() : true)) {
              <li class="nav-item me-2"
                [ngbNavItem]="link.fragment">
                <a ngbNavLink [routerLink]="link.fragment" [queryParams]="link.queryParams" (click)="isNavBarCollapsed.set(true)">{{ link.title }}</a>
              </li>
            }
          }
        </ul>
      </div>
      <div class="d-flex">
        <button class="btn btn-toolbar mx-2" (click)="toggleDarkMode()">
          @if (getTheme() === 'light') {
            <i class="bi-moon-fill"></i>
          } @else {
            <i class="bi-sun-fill"></i>
          }
        </button>
        <div class="mx-2">
          @switch (locale) {
            @case ('pl') {
              <a href="/en"><img ngSrc="./assets/gb.svg" alt="en" height="40" width="55"></a>
            }
            @case ('en') {
              <a href="/pl"><img ngSrc="./assets/pl.svg" alt="pl" height="40" width="55"></a>
            }
          }
        </div>
        @if (userService.$user | async; as user) {
          <div>
            @if (user.impersonatedBy) {
              <button class="btn btn-outline-warning mx-2" (click)="exitImpersonate()" i18n>Zakończ przejmowanie sesji</button>
            }
            <span class="username">{{ user.name }} {{ user.surname }}</span>
            <a i18n class="btn btn-secondary mx-2" href="/logout">Wyloguj</a>
          </div>
        } @else {
          <a i18n class="btn btn-secondary mx-2" href="/login?service={{getServiceUrl()}}">Zaloguj</a>
        }
      </div>
    </div>
  </nav>
  <app-toasts />
  <div class="container">
    <router-outlet />
  </div>
  <app-footer />
</div>
